// extracted by mini-css-extract-plugin
export var textInput = "_fb-0";